module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    staticClass: "checkin-tabs pos-tabs",
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent"
  }, [_c('v-tabs-slider', {
    staticClass: "default-skyblue"
  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-tabs-item', {
      key: item.id,
      attrs: {
        "href": '#tab-' + item.id,
        "disabled": _vm.$v.model.$invalid && (item.id === 2)
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t")])
  })], 2), _vm._v(" "), _c('v-tabs-items', _vm._l((_vm.items.length), function(i) {
    return _c('v-tabs-content', {
      key: i,
      attrs: {
        "id": 'tab-' + i
      }
    }, [(i === 1) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "my-4": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-left": "",
        "mb-2": ""
      }
    }, [_c('label', {
      staticClass: "label-title"
    }, [_vm._v("Completa los datos")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-left": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Buscar por")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "items": _vm.searchMethods,
        "item-text": "name",
        "item-value": "id",
        "label": "Buscar por...",
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      on: {
        "input": function($event) {
          _vm.cleanModel('search')
        }
      },
      model: {
        value: (_vm.searchBy),
        callback: function($$v) {
          _vm.searchBy = $$v
        },
        expression: "searchBy"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Sucursal")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "label": "Elige la sucursal",
        "items": _vm.subsidiaries,
        "item-text": "name",
        "item-value": "id",
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      on: {
        "input": _vm.cleanModel
      },
      model: {
        value: (_vm.subsidiary),
        callback: function($$v) {
          _vm.subsidiary = _vm._n($$v)
        },
        expression: "subsidiary"
      }
    })], 1), _vm._v(" "), (_vm.searchByRoom) ? _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Nº de Habitación")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "number",
        "placeholder": "Nº",
        "disabled": _vm.roomDisabled
      },
      on: {
        "blur": _vm.searchCustomerByRoom
      },
      model: {
        value: (_vm.roomFilter),
        callback: function($$v) {
          _vm.roomFilter = _vm._n($$v)
        },
        expression: "roomFilter"
      }
    }), _vm._v(" "), (_vm.$v.roomFilter && _vm.$v.roomFilter.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEl número de habitación es requerido\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Tipo de identificación")]), _vm._v(" "), _c('type-document-input', {
      on: {
        "customer-data": _vm.getCustomerData,
        "customer-not-found": _vm.notFoundCustomer
      }
    }), _vm._v(" "), (_vm.$v.model.numDocument && _vm.$v.model.numDocument.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEl número de documento es requerido\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$v.model.numDocument && _vm.$v.model.numDocument.$invalid &&
      _vm.$v.model.numDocument.$params.minLength) ? _c('p', {
      staticClass: "caption red--text mb-0"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEs necesario ingresar " + _vm._s(_vm.$v.model.numDocument.$params.minLength.min) + " dígitos\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.searchById),
        expression: "searchById"
      }],
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Nº de Habitación")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "items": _vm.bookings,
        "item-text": "codeRoom",
        "item-value": "id",
        "disabled": !_vm.model.numDocument ||
          _vm.roomsEmpty,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.model.idRoom),
        callback: function($$v) {
          _vm.model.idRoom = $$v
        },
        expression: "model.idRoom"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      class: {
        'xs6': !_vm.naturalPerson
      },
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v(_vm._s(_vm.nameLabel))]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.name),
        callback: function($$v) {
          _vm.model.name = $$v
        },
        expression: "model.name"
      }
    }), _vm._v(" "), (_vm.$v.model.name && _vm.$v.model.name.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.nameMessage) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.naturalPerson) ? _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Apellidos")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "placeholder": "Completos",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.lastname),
        callback: function($$v) {
          _vm.model.lastname = $$v
        },
        expression: "model.lastname"
      }
    }), _vm._v(" "), (_vm.$v.model.lastname && _vm.$v.model.lastname.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEl apellido es requerido\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "email",
        "placeholder": "nombre@mail.com",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.email),
        callback: function($$v) {
          _vm.model.email = $$v
        },
        expression: "model.email"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Celular")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "number",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.cellPhone),
        callback: function($$v) {
          _vm.model.cellPhone = $$v
        },
        expression: "model.cellPhone"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Fecha de nacimiento")]), _vm._v(" "), _c('v-menu', {
      staticClass: "menu-date-picker",
      attrs: {
        "lazy": "",
        "nudge-left": 40,
        "transition": "scale-transition",
        "offset-y": "",
        "full-width": "",
        "max-width": "290px"
      },
      model: {
        value: (_vm.dateBirthPos),
        callback: function($$v) {
          _vm.dateBirthPos = $$v
        },
        expression: "dateBirthPos"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Fecha de nacimiento",
        "disabled": !_vm.dateBirthPosStart,
        "append-icon": _vm.arrowIconStart,
        "single-line": "",
        "hide-details": "",
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (_vm.dateBirthPosStart),
        callback: function($$v) {
          _vm.dateBirthPosStart = $$v
        },
        expression: "dateBirthPosStart"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "no-title": "",
        "year-icon": "",
        "scrollable": ""
      },
      model: {
        value: (_vm.dateBirthPosStart),
        callback: function($$v) {
          _vm.dateBirthPosStart = $$v
        },
        expression: "dateBirthPosStart"
      }
    })], 1)], 1), _vm._v(" "), (_vm.naturalPerson) ? _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Género")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.genders,
        "hide-details": "",
        "disabled": !_vm.model.numDocument,
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.model.gender),
        callback: function($$v) {
          _vm.model.gender = $$v
        },
        expression: "model.gender"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.naturalPerson) ? _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Estado civil")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.civilStatus,
        "hide-details": "",
        "disabled": !_vm.model.numDocument,
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.model.civilStatus),
        callback: function($$v) {
          _vm.model.civilStatus = $$v
        },
        expression: "model.civilStatus"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("País")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select filter-select-autocomplete",
      attrs: {
        "autocomplete": "",
        "items": _vm.countries,
        "item-text": "name",
        "item-value": "id",
        "hide-details": "",
        "disabled": !_vm.model.numDocument,
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.model.countryId),
        callback: function($$v) {
          _vm.model.countryId = $$v
        },
        expression: "model.countryId"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Dirección")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.address),
        callback: function($$v) {
          _vm.model.address = $$v
        },
        expression: "model.address"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "justify-end": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action back",
      attrs: {
        "type": "button",
        "info": ""
      },
      on: {
        "click": _vm.goToSummary
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tAnónimo\n\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), (_vm.roomsEmpty && _vm.searchById && !_vm.customerExist) ? _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action back",
      attrs: {
        "disabled": _vm.$v.model.$invalid,
        "info": "",
        "type": "button"
      },
      on: {
        "click": _vm.register
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tRegistrar\n\t\t\t\t\t\t\t\t\t\t")])], 1) : _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action back",
      attrs: {
        "disabled": _vm.$v.model.$invalid,
        "info": "",
        "type": "button"
      },
      on: {
        "click": _vm.goToCheckout
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tContinuar\n\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1) : _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "my-4": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs9": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openProductsModal($event)
        }
      }
    }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Agregar\n\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('payment-dialog', {
      on: {
        "products-to-pay": _vm.updateProducts,
        "close-modal": function($event) {
          _vm.dialog = false
        }
      },
      model: {
        value: (_vm.dialog),
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "total-amount"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\tTotal " + _vm._s(_vm._f("currency")(_vm._f("round")(_vm.totalAmount), _vm.symbol)) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "my-2": ""
      }
    }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "pb-0": ""
      }
    }, [_c('table-run', {
      staticClass: "no-selectable-table",
      attrs: {
        "columns": _vm.summaryColumns,
        "rows": _vm.localSummaryRows,
        "include-delete": false,
        "include-delete-single": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-search": false,
        "include-switch": false,
        "include-settings": false,
        "selectable": false
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.createdAt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.subTotal), _vm.symbol)))]), _vm._v(" "), _c('td', [_c('v-btn', {
            staticClass: "error--text",
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                _vm.deleteLocalProduct(props.row)
              }
            }
          }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)]
        }
      }])
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "justify-center": "",
        "my-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pr-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action back",
      attrs: {
        "info": "",
        "type": "button"
      },
      on: {
        "click": _vm.back
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tVolver\n\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "type": "button",
        "disabled": _vm.saleDisabled
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openSaleModal($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tCobrar\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "persistent": "",
        "width": "850px"
      },
      model: {
        value: (_vm.saleModal),
        callback: function($$v) {
          _vm.saleModal = $$v
        },
        expression: "saleModal"
      }
    }, [_c('v-card', {
      staticClass: "pb-5",
      attrs: {
        "height": "auto"
      }
    }, [_c('v-card-title', {
      staticClass: "headline"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tVentas\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-4": ""
      }
    }, [_c('v-divider')], 1), _vm._v(" "), (_vm.billingActive) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-2": "",
        "pl-2": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "input-checkbox input-booking",
      attrs: {
        "label": "Exonerar impuestos",
        "color": "info",
        "hide-details": ""
      },
      on: {
        "change": _vm.validateExoneration
      },
      model: {
        value: (_vm.flagTaxes),
        callback: function($$v) {
          _vm.flagTaxes = $$v
        },
        expression: "flagTaxes"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-2": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('label', {
      staticClass: "label-sale-modal"
    }, [_vm._v("Tipo de documento")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [(_vm.documentTypes.length > 0) ? _c('v-radio-group', {
      attrs: {
        "row": ""
      },
      on: {
        "change": _vm.setTypeDocument
      },
      model: {
        value: (_vm.saleModel.typeDocumentCode),
        callback: function($$v) {
          _vm.saleModel.typeDocumentCode = $$v
        },
        expression: "saleModel.typeDocumentCode"
      }
    }, [_c('v-radio', {
      staticClass: "sale-radio-button",
      attrs: {
        "color": "info",
        "label": _vm.documentTypes[0].documentType.name,
        "value": _vm.documentTypes[0].documentType.code
      }
    }), _vm._v(" "), _c('v-radio', {
      staticClass: "sale-radio-button",
      attrs: {
        "color": "info",
        "disabled": _vm.cantBilling,
        "label": _vm.documentTypes[1].documentType.name,
        "value": _vm.documentTypes[1].documentType.code
      }
    }), _vm._v(" "), _c('v-radio', {
      staticClass: "sale-radio-button",
      attrs: {
        "color": "info",
        "label": _vm.documentTypes[2].documentType.name,
        "value": _vm.documentTypes[2].documentType.code
      }
    })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-3": "",
        "text-xs-left": ""
      }
    }, [_c('label', {
      staticClass: "label-sale-modal"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tTipo de cambio\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pr-3": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text"
      },
      on: {
        "blur": function($event) {
          _vm.changeAmounts(_vm.currencySelected)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.changeAmounts(_vm.currencySelected)
        }
      },
      model: {
        value: (_vm.exchangeRate),
        callback: function($$v) {
          _vm.exchangeRate = $$v
        },
        expression: "exchangeRate"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "code",
        "item-value": "code",
        "label": "Moneda",
        "items": _vm.currencies,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      on: {
        "input": _vm.changeAmounts
      },
      model: {
        value: (_vm.currencySelected),
        callback: function($$v) {
          _vm.currencySelected = $$v
        },
        expression: "currencySelected"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "mb-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": "",
        "align-center": "",
        "justify-end": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": "",
        "text-xs-right": "",
        "pr-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Recargo al Consumo")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "number"
      },
      model: {
        value: (_vm.tip),
        callback: function($$v) {
          _vm.tip = $$v
        },
        expression: "tip"
      }
    })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "pr-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-3": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "name",
        "item-value": "code",
        "label": "Modo de pago",
        "items": _vm.paymentMethods,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      on: {
        "input": _vm.setPaymentMethod
      },
      model: {
        value: (_vm.saleModel.paymentMethodCode),
        callback: function($$v) {
          _vm.saleModel.paymentMethodCode = $$v
        },
        expression: "saleModel.paymentMethodCode"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs10": "",
        "pl-3": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select filter-select-multiple",
      attrs: {
        "chips": "",
        "hide-details": "",
        "item-text": "name",
        "item-value": "code",
        "disabled": _vm.invalid,
        "items": _vm.typePayments,
        "label": "Selecciona los tipos de pago a realizar",
        "multiple": "",
        "return-object": "",
        "single-line": ""
      },
      on: {
        "input": _vm.addPays
      },
      model: {
        value: (_vm.typePaymentsSelected),
        callback: function($$v) {
          _vm.typePaymentsSelected = $$v
        },
        expression: "typePaymentsSelected"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "px-3": "",
        "mt-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((_vm.paysByTypePayment), function(pay) {
      return _c('v-flex', {
        key: pay.code,
        attrs: {
          "xs2": "",
          "text-xs-left": "",
          "pr-2": ""
        }
      }, [_c('label', {
        staticClass: "label-form"
      }, [_vm._v(_vm._s(pay.name))]), _vm._v(" "), _c('v-text-field', {
        staticClass: "input-border-inset",
        attrs: {
          "type": "number"
        },
        model: {
          value: (pay.amount),
          callback: function($$v) {
            pay.amount = _vm._n($$v)
          },
          expression: "pay.amount"
        }
      })], 1)
    }))], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mt-3": ""
      }
    }, [_c('div', {
      staticClass: "bar-data"
    }, [_c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCliente:\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.model.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.documentTypeName) + ":\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.model.numDocument))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tTipo de Documento:\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.saleCustomer.typeDocument))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tModo de pago:\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.saleCustomer.paymentMethod))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tMoneda:\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.currencySelected))])])])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mt-3": ""
      }
    }, [_c('table-run', {
      staticClass: "no-selectable-table",
      attrs: {
        "columns": _vm.localProductsColumns,
        "rows": _vm.localSummaryRows,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-search": false,
        "include-switch": false,
        "include-settings": false,
        "include-delete-single": false,
        "selectable": false
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.createdAt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.categoryName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.quantity))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.symbol) + " "), _c('input', {
            directives: [{
              name: "model",
              rawName: "v-model.number",
              value: (props.row.subTotal),
              expression: "props.row.subTotal",
              modifiers: {
                "number": true
              }
            }],
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (props.row.subTotal)
            },
            on: {
              "input": function($event) {
                if ($event.target.composing) { return; }
                props.row.subTotal = _vm._n($event.target.value)
              },
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          }), _vm._v(" "), (props.row.flagIgvRequired) ? _c('v-btn', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: 'Impuesto obligatorio'
              }),
              expression: "{ html: 'Impuesto obligatorio' }",
              arg: "top"
            }],
            staticClass: "warning--text",
            attrs: {
              "icon": ""
            }
          }, [_c('v-icon', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\twarning\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1) : _vm._e()], 1)]
        }
      }])
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "wrap": "",
        "mt-2": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "px-3": "",
        "text-xs-left": ""
      }
    }, [_c('label', [_vm._v("Observación:")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset input-textarea input-note mt-1",
      attrs: {
        "no-resize": "",
        "multi-line": "",
        "placeholder": "Escriba aquí",
        "rows": 2,
        "textarea": ""
      },
      model: {
        value: (_vm.commentary),
        callback: function($$v) {
          _vm.commentary = $$v
        },
        expression: "commentary"
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "my-3": "",
        "align-end": "",
        "justify-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pr-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action",
      attrs: {
        "type": "button",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.closeSaleModal($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "disabled": _vm.$v.saleCustomer.$invalid ||
          _vm.disableGenerateSale || _vm.validateAmount ||
          _vm.invalid || _vm.disabledSave
      },
      nativeOn: {
        "click": function($event) {
          _vm.generateSale($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-3": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-darkblue white--text",
      attrs: {
        "disabled": _vm.$v.saleCustomer.$invalid ||
          _vm.validateAmount
      },
      nativeOn: {
        "click": function($event) {
          _vm.postPreview($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tPrevisualización\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
  }))], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31fb11f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/pos/Pos.vue
// module id = 1613
// module chunks = 22